import { type ISbStoryData } from '@storyblok/react/rsc'

import { type ContentType } from '../../storyblok'

export const storyAccessorHasNoIndexInSeoRobots = (
  story: ISbStoryData<ContentType>,
): boolean => {
  const { seoRobots } = story.content

  if (!seoRobots || typeof seoRobots !== 'string') {
    return false
  }

  return seoRobots.includes('noindex')
}
